import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HitApi } from "../../Api/ApiHit";
import { searchBilling, searchClient, searchClientSurvey } from "../../constant/Constant";
import { useDispatch, useSelector } from "react-redux";
import MySearchableSelect from "../../components/MyComponent/BillingSearchableSelect";
import { Calendar, Gift, Loader2, PlusCircle } from "lucide-react";
import { setDataAction } from "../../redux/Actions/SetDataAction";
import { SET_BILLING_MEMBERSHIP_DATA, SET_BILLING_PACKAGE_DATA, SET_BILLING_PRODUCTS_DATA, SET_BILLING_SERVICES_DATA, SET_CLIENT_INFO, SET_QUESTIONS_DATA, SET_SERVICE_INFO, SET_SURVEY_RESPONSE_DATA, SET_BILLING_AUTOBILL_DATA } from "../../redux/ActionName/ActionName";
import { ServiceSection } from "./ServiceSection";
import AppButton from "../../components/AppButton/AppButton";
import { MemberShipSection } from "./MemberShipSection";
import { ProductSection } from "./ProductSection";
import { PackageSection } from "./PackageSection";
import { PriceSection } from "./PriceSection";
import BillSummary from "./BillSummary";
import { AutoBillingSection } from "./AutoBillingSection";
import { calculateBillSummary, transformServiceData } from "../../utils/utils";
import ClientSurveyResponse from "../../components/ClientSurvey/ClientSurvey";
import toast from "react-hot-toast";

const Billing = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer)
    const surveyData = useSelector(state => state.CreateSurvey)
    console.log("BillingReducer-----hello data", BillingReducer);

    const dispatch = useDispatch();
    const { id } = useParams();
    const [data, setData] = useState(null);

    const [loading, setIsLoading] = useState(false);
    useEffect(() => {
        if (id) {
            if (data === null) {
                loadBillingData();
            }
        }
    }, [id, dispatch]);
    const loadBillingData = () => {
        const json = {
            page: 1,
            limit: 10,
            search: {
                _id: id
            }
        };
        HitApi(json, searchBilling).then(res => {
            if (res?.data) {
                console.log("res?.data-------", res?.data);
                setData(true)
                dispatch(setDataAction(res?.data?.[0]?.clientInfo, SET_CLIENT_INFO));
                console.log("12345", res?.data?.[0]?.clientInfo);
                var updateServiceData = transformServiceData(res?.data?.[0]?.serviceInfo)
                console.log("updateServiceData-------", updateServiceData);
                dispatch(setDataAction(updateServiceData, SET_SERVICE_INFO));
                const updatedBillingReducer = { ...BillingReducer, selectedServices: updateServiceData, clientInfo: res?.data?.[0]?.clientInfo[0] };
                calculateBillSummary(updatedBillingReducer, dispatch);
            }
        }).catch(error => {
            console.error("Error fetching billing data:", error);
        });
    };
    //yaha pe survey ka data load krra hu 
    // useEffect(() => {
    //     if (BillingReducer?.clientInfo?._id)
    //         loadServey()
    // }, [BillingReducer?.clientInfo?._id])
    // const loadServey = () => {
    //     setIsLoading(true)
    //     const json = {
    //         page: 1, limt: 10, search: {
    //             client_id: BillingReducer?.clientInfo?._id
    //         }
    //     }
    //     HitApi(json, searchClientSurvey).then((res) => {
    //         setIsLoading(false)
    //         if (res?.statusCode === 200) {
    //             if (res?.data.length > 0)
    //                 dispatch(setDataAction(res?.data?.[0].questions, SET_SURVEY_RESPONSE_DATA))
    //             else {
    //                 dispatch(setDataAction([], SET_SURVEY_RESPONSE_DATA))
    //             }
    //         }
    //         else {
    //             toast.error(res.message)
    //         }
    //     })
    // }
    ////////////////////////////////////////////////////


    const addNewService = () => {
        const newService = { price: 0, quantity: 1, total: 0 };
        const currentProducts = BillingReducer?.selectedServices || [];
        dispatch(setDataAction([...currentProducts, newService], SET_BILLING_SERVICES_DATA));
    };
    const addNewProduct = () => {
        const newProduct = { price: 0, quantity: 1, total: 0 };
        const currentProducts = BillingReducer?.selectedProducts || [];
        dispatch(setDataAction([...currentProducts, newProduct], SET_BILLING_PRODUCTS_DATA));
    };
    const addNewMembership = () => {
        const newMembership = { price: 0, total: 0 };
        const currentMemberships = BillingReducer?.selectedMemberships || [];
        dispatch(setDataAction([...currentMemberships, newMembership], SET_BILLING_MEMBERSHIP_DATA));
    };
    const addNewPackage = () => {
        const newPackage = { price: 0, total: 0 };
        const currentPackages = BillingReducer?.selectedPackages || [];
        dispatch(setDataAction([...currentPackages, newPackage], SET_BILLING_PACKAGE_DATA));
    };
    const addNewAutoBill = () => {
        const newAutoBill = { frequency: '', startDate: '', endDate: '', amount: 0, total: 0 };
        const currentAutoBills = BillingReducer?.selectedAutoBills || [];
        dispatch(setDataAction([...currentAutoBills, newAutoBill], SET_BILLING_AUTOBILL_DATA));
    };
    const handelCient = (value) => {
        console.log("value from select", value);
        dispatch(setDataAction(value, SET_CLIENT_INFO))
        const updatedBillingReducer = { ...BillingReducer, clientInfo: value };
        calculateBillSummary(updatedBillingReducer, dispatch);
    }

    console.log("BillingReducer for cheking", BillingReducer);

    return (
        id && BillingReducer?.clientInfo === null ?
            <div className="flex justify-center items-center h-64">
                <div className="text-lg">Loading billing data...</div>
            </div>
            :
            <div>
                {/* <div className="gap-6 grid grid-cols-3 "> */}
                <div className="bg-white rounded-xl shadow-lg p-6 mb-6 w-full col-span-2">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800">Create Invoice</h1>
                            <p className="text-gray-600 mt-1">Create and manage salon invoices</p>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="text-right">
                                <p className="text-sm text-gray-500">Bill Date</p>
                                <p className="font-semibold text-gray-800">
                                    {new Date().toLocaleDateString()}
                                </p>
                            </div>
                            <Calendar className="text-gray-800" size={20} />
                        </div>
                    </div>
                    <div >
                        <MySearchableSelect clientSelect={true} giveFullElement={true} value={BillingReducer?.clientInfo?.name ? BillingReducer?.clientInfo?.name : ""} optionLable="name" api={searchClient} onChange={handelCient} title="Search Client" placeholder="Search By Name/Contact/Address/File No/Card Number (Atleast 3 Characters are required)" />
                    </div>
                </div>
                {/* <div className="mb-5" >
                        {loading ? (
                            <div className="flex items-center justify-center h-64">
                                <Loader2 className="animate-spin w-8 h-8 text-gray-500" />
                            </div>
                        ) : (
                            <ClientSurveyResponse data={surveyData?.response} />
                        )}
                    </div> */}
                {/* </div> */}

                <div className="grid grid-cols-3 gap-6">
                    <div className="col-span-2">
                        <ServiceSection />
                        <div className="mt-5">
                            <ProductSection />
                        </div>
                        <div className="mt-5">
                            <MemberShipSection />
                        </div>
                        <div className="mt-5">
                            <PackageSection />
                        </div>
                        <div className="mt-5">
                            <AutoBillingSection />
                        </div>

                        <div className="flex flex-wrap gap-3 mt-5">
                            <AppButton onClick={addNewService} buttontext={"Add Service"} icon={PlusCircle} />
                            <AppButton onClick={addNewProduct} buttontext={"Add Product"} icon={PlusCircle} />
                            <AppButton onClick={addNewMembership} buttontext={"Add Membership"} icon={PlusCircle} />
                            <AppButton onClick={addNewPackage} buttontext={"Add Package"} icon={PlusCircle} />
                            <AppButton onClick={addNewAutoBill} buttontext={"Add Auto Bill"} icon={PlusCircle} />
                            <AppButton buttontext={"Gift Card"} icon={Gift} />
                        </div>
                        <div className="mt-5">
                            <PriceSection />
                        </div>
                    </div>
                    <div>
                        <BillSummary />
                    </div>
                </div>
            </div>
    )
}

export default Billing;